<div class="flex w-full px-3 justify-between items-center">
  <div class="w-1/4">
    <p>Titel</p>
  </div>
  <div class="w-1/5"><p>Skickad</p></div>
  <div class="w-1/5"><p>Antal den är aktiv för</p></div>
  <div class="w-1/4"><p>Antal som sett nyheten</p></div>
  <div class="w-12 relative h-8"><p [hidden]="!forActive" class="text-right absolute whitespace-nowrap right-[-10px]">Inaktivera nyhet</p></div>
</div>
